import Vue from "vue";
import VueRouter  from "vue-router";
//import i18n from '@/i18n'
import store from '@/store/store'
//const $t = i18n();

Vue.use(VueRouter);

const App = () => import('@/layouts/Layout.vue');
const Backend = () => import('@/components/Admin/Layout.vue');
const routes = [
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "login" */ '@/layouts/NotFound.vue'),    
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import(/* webpackChunkName: "login" */ '@/layouts/Maintenance.vue'),    
  },
  {
    path: "/",
    component: App,
    children: [
      {
        path: '',
        name: 'Main',
        component: () => import( '@/components/Home/Home.vue')
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import( '@/components/Contact/Contact.vue')
      }, 
      {
        path: 'agb',
        name: 'AGB',
        component: () => import( '@/components/Sites/AGB.vue')
      }, 
      {
        path: 'datenschutz',
        name: 'Privacy',
        component: () => import( '@/components/Sites/Privacy.vue')
      }, 
      {
        path: 'impressum',
        name: 'Imprint',
        component: () => import( '@/components/Sites/Imprint.vue')
      }, 
      /* {
        path: 'preise',
        name: 'Preise',
        component: () => import(webpackChunkName: "preise"  '@/components/Pricing/Pricing.vue')
      }, */
      {
        path: 'account',
        meta: {
            auth:true
        },
        component: () => import(/* webpackChunkName: "Account" */ '@/components/Account/Account.vue'),
        children: [          
          {
            path: 'overview',
            name: 'Overview',
            meta: {
                auth:true
            },
            component: () => import(/* webpackChunkName: "Account" */ '@/components/Account/Overview.vue'),
          },
          {
            path: 'profile',
            name: 'Profile',
            meta: {
                auth:true
            },
            component: () => import(/* webpackChunkName: "Account" */ '@/components/Account/Profile.vue'),
          },
          {
            path: 'orders',
            name: 'Orders',
            meta: {
                auth:true
            },
            component: () => import(/* webpackChunkName: "Account" */ '@/components/Account/Orders.vue'),
          },
          {
            path: 'orders/details/:orderid',
            name: 'OrderDetails',
            meta: {
                auth:true
            },
            component: () => import(/* webpackChunkName: "Account" */ '@/components/Account/OrderDetails.vue'),
          },
          {
            path: 'abonnement',
            name: 'Abonnement',
            meta: {
                auth:true
            },
            component: () => import(/* webpackChunkName: "Profile" */ '@/components/Account/Abonnement.vue'),
          },
        ]
      },
      {
        path: '/checkout',
        name: 'checkout',
        props: true ,
        meta: {
            auth:true
        },
        component: () => import(/* webpackChunkName: "Account" */ '@/components/Checkout/Checkout.vue'),        
      },
      {
        path: '/checkout/:type/:id',
        name: 'checkoutone',
        props: true ,
        meta: {
            auth:true
        },
        component: () => import(/* webpackChunkName: "Account" */ '@/components/Checkout/CheckoutOne.vue'),        
      }
    ]
  },
  {
    path: '/paymentcompletion',
    name: 'paymentcompletion',
    meta: {
        auth:true
    },
    component: () => import(/* webpackChunkName: "Account" */ '@/components/Checkout/PaymentCompletion.vue'),
  },  
  {
    path: '/backend',
    name: 'Backend',
    meta: {
        auth:true
    },
    component: Backend
  }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })
  
router.beforeEach(async (to, from, next) => {
  console.log(to)
  const user = localStorage.getItem('current_user')
  const loggedIn = JSON.parse(user)
  if (to.matched.some(record => record.meta.auth) && !loggedIn) {    
    store.dispatch('accountsModule/logout')
    next({name: 'Main'})
    //location.reload()
  }
  next()
})

export default router;